<template>
  <div>
    <!-- Header -->
    <div class="row align-items-center">
      <div class="border-0 mb-4">
        <div class="card-header py-3 no-bg bg-transparent d-flex align-items-center px-0 justify-content-between border-bottom flex-wrap">
          <h3 class="fw-bold mb-0">Şablonu dəyiş</h3>
        </div>
      </div>
    </div>

    <!-- Body -->
    <div class="card-body">
      <form @submit.prevent="updateMessageTemplate">
        <!-- Input fields -->
        <div class="row g-3 align-items-center">
          <div class="col-md-6">
            <label for="name" class="form-label">Adi</label>
            <input type="text" v-model="nmsgtemplate.name" v-validate="{ required: true }" name="name" id="name" class="form-control" required="">
            <span class="inputError">{{ errors.first('name') }}</span>
          </div>

          <!-- Template text -->
          <div class="w-100 templateText">
            <label for="templateText" class="form-label">Mətn</label>
            <br />
            <textarea class="w-100 h-100 form-control" v-model="nmsgtemplate.content" v-validate="{ required: true }" name="templateText" id="templateText"></textarea>
            <span class="inputError">{{ errors.first('templateText') }}</span>
            <p class="text-end fs-5"><span>Max simvol:</span><span>480</span> &nbsp; | &nbsp;<span>SMS say:</span><b>{{ smsSay }}</b> &nbsp; | &nbsp;<span>SMS uzunluq:</span><b>{{ smsUzunluq }}</b></p>
          </div>
        </div>

        <!-- Buttons -->
        <div class="d-flex justify-content-between buttonsDiv">
          <button type="submit" class="btn btn-primary mt-4" :disabled="loading">Yaddaşa yaz</button>
          <!-- <button type="button" class="btn btn-danger mt-4 text-light" @click.prevent="triggerDeleteModal">Ləğv et</button> -->
        </div>
      </form>
    </div>

    <!-- <DeleteModal v-if="showDeleteModal" @closeDeleteModal="showDeleteModal = false" :text="modalText" :deletingAPI="deletingAPI" :objectId="nmsgtemplate.id"/> -->
  </div>
</template>

<script>
import jwtInterceptor from '../../../jwt.interceptor'
import user from '../../../store/user'
import DeleteModal from '../DeleteModal.vue'

export default {
  name: 'UpdateMessageTemplates',
  components: {
    DeleteModal
  },
  data() {
    return {
      loading: false,
      showDeleteModal: false,
      modalText: {
        object: 'Şablon',
        header: 'Şablonun ləğv edilməsi',
        question: 'Şablonun ləğv edilməsinə əminsinizmi?'
      },
      deletingAPI: '/SmShablons',
      nmsgtemplate: {
        content: '',
        text: ''
      },
    }
  },
  methods: {
    triggerDeleteModal() {
      this.showDeleteModal = true
    },
    async updateMessageTemplate() {
      this.loading = true
      
      const validForm = await this.isFormValid()
      if (validForm) {
        jwtInterceptor.put(this.$store.getters.getUrl + "/SmShablons/"+this.nmsgtemplate.id, this.nmsgtemplate).then(response => {
          if (response.data.isError === null) {
            this.$toast.success("Şablon uğurla dəyişdirildi!", {
              position: "top-right"
            })
            this.loading = false
            this.$router.go(-1);
          }
          else {
            this.$toast.error("Bir xəta baş verdi. Bir daha sınayın!", {
              position: "top-right"
            });
            this.loading = false
          }
        }).catch(() => {
          this.$toast.error('Bir xəta baş verdi.', {
            position: "top-right"
          });
          this.loading = false
        })
      } 
      else {
        this.$toast.error("Xanalar düzgün doldurulmayıb. Bir daha xanaları yoxlayın!", {
          position: "top-right"
        })
        this.loading = false
      }
      this.loading = false
    },
    isFormValid() {
      // eslint-disable-next-line vue/no-async-in-computed-properties, no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const valid = await this.$validator.validate();
          resolve(valid);
        } catch (error) {
          reject(error);
        }
      });
    },
  },
  created() {
    this.nmsgtemplate = user.getters.getTemplateUpdate
  },
  computed: {
    smsSay(){
      return Math.ceil(this.nmsgtemplate.content.length/160);
    },
    smsUzunluq(){
      return this.nmsgtemplate.content.length;
    }
  }
}
</script>

<style>
.buttonsDiv {
  width: 20%
}

.templateText {
  height: 150px;
  margin-bottom: 2rem;
}

.justify-content-custom {
  justify-content: space-between;
}

@media screen and (max-width: 881px) {
  .buttonsDiv {
    width: 100%
  }
}

@media screen and (max-width: 615px) {
  .justify-content-custom {
    justify-content: space-around !important;
  }
}
</style>